/**
 * 
 *  created by AHMED HAYEL 
 *
 */

export class Boitier {
    idBoitier: number;
    label: string;
    numBoitier: number;
    emplacement: string;
    dateLastTrame: number;
    vitesse: number;
    etatBoitier: string;
    gpsLastTrame: number;
    gsmLastTrame: number;
    stat: boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/Model/Boitier.ts